<div class="menu" *ngIf="user">
  <div *ngIf="clients.length > 1" class="gl-menu__client">
    <div class="gl-menu__client--item menu-item hide-on-med-and-down">
      <button
        class="gl-client-button"
        [ngClass]="{ active: clientDropdownVisible }"
        type="button"
        (click)="toggleClientDropdown()"
      >
        <span class="text--ellipsis">{{ selectedClient.name }}</span>
        <i [className]="clientDropdownVisible ? 'glicon-up-arrow' : 'glicon-down-arrow'"></i>
      </button>

      <div class="gl-panel-accounts" [ngClass]="{ visible: clientDropdownVisible }">
        <div
          *ngFor="let client of clients"
          [className]="
            client.id === selectedClient.clientId ? 'gl-panel-accounts__item active' : 'gl-panel-accounts__item'
          "
          (click)="changeSelectedClient(client.id)"
        >
          <span>{{ client.name }}</span>
        </div>
      </div>
    </div>
    <gl-tooltip posBottom [text]="'dashboard.clients.selectClientsTooltip' | translate"></gl-tooltip>
  </div>

  <div class="menu-item hide-on-med-and-down" *lmsProfileGuard="'app.selectLang'">
    <button
      class="un-btn btn-language"
      [ngClass]="{ active: langDropdownVisible }"
      type="button"
      (click)="toggleLangDropdown()"
    >
      <span [ngClass]="language" class="gl-language-icon"></span>
      <span class="lang">{{ language }}</span>
      <i [className]="langDropdownVisible ? 'glicon-up-arrow' : 'glicon-down-arrow'" class="glicon-down-arrow"></i>
    </button>

    <div class="account-submenu" [ngClass]="{ visible: langDropdownVisible }">
      <div [ngClass]="{ active: language == 'en' }" class="gl-menu__languages" (click)="changeLanguage('en')" id="en">
        <span class="flag-circle en"></span>
        <span>{{ 'languages.english' | translate }}</span>
      </div>
      <div [ngClass]="{ active: language == 'es' }" class="gl-menu__languages" (click)="changeLanguage('es')" id="es">
        <span class="flag-circle es"></span>
        <span>{{ 'languages.spanish' | translate }}</span>
      </div>
      <div [ngClass]="{ active: language == 'fr' }" class="gl-menu__languages" (click)="changeLanguage('fr')" id="fr">
        <span class="flag-circle fr"></span>
        <span>{{ 'languages.french' | translate }}</span>
      </div>
      <div [ngClass]="{ active: language == 'de' }" class="gl-menu__languages" (click)="changeLanguage('de')" id="de">
        <span class="flag-circle de"></span>
        <span>{{ 'languages.german' | translate }}</span>
      </div>
    </div>
  </div>

  <div class="menu-item hide-on-med-and-down" *ngIf="apps.length">
    <button
      type="button"
      class="un-btn btn-help"
      [ngClass]="{ active: appsDropdownVisible }"
      (click)="toggleAppsDropdown()"
    >
      <i class="glicon-apps"></i>
    </button>
    <div class="account-submenu hide-on-med-and-down" [ngClass]="{ visible: appsDropdownVisible }">
      <ul class="account-submenu__list apps-list">
        <li
          *ngFor="let app of apps | showfilter"
          [class.apps-list__item--active]="app.state === 'active'"
          class="account-submenu__item apps-list__item"
          (click)="launchApp(app)"
        >
          <img [src]="app.icon" class="app-icon" />
          <span>{{ app.label | translate }}</span>
        </li>
      </ul>
    </div>
  </div>

  <div class="menu-item hide-on-med-and-down">
    <button
      type="button"
      class="un-btn btn-help font-size-large"
      [ngClass]="{ active: helpDropdownVisible }"
      (click)="toggleHelpDropdown()"
    >
      <i class="glicon-help"></i>
    </button>
    <div
      class="account-submenu account-submenu__help hide-on-med-and-down"
      [ngClass]="{ visible: helpDropdownVisible }"
    >
      <ul class="account-submenu__list">
        <!-- TODO: Ocultar hasta que los vídeos estén actualizados -->
        <!-- <li class="account-submenu__item">
            <a href="{{ 'help.tutorialsUrl' | translate }}" target="_blank">{{
              'help.tutorialsLabel' | translate
            }}</a>
          </li> -->
        <li class="account-submenu__item">
          <span>{{ 'help.title' | translate }}</span>
        </li>
        <li class="account-submenu__item">
          <a href="{{ 'help.FAQsUrl' | translate }}" target="_blank" rel="noopener noreferrer">
            <span class="glicon-book-open"></span>
            <div>
              <span>{{ 'help.faqTitle' | translate }}</span>
              <span>{{ 'help.faqSubTitle' | translate }}</span>
            </div>
          </a>
        </li>
        <li class="account-submenu__item">
          <a
            href="{{ (user && user.role === 'expert' ? 'help.incidentUrlExpert' : 'help.incidentUrl') | translate }}"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="glicon-support"></span>
            <div>
              <span>{{ 'help.contactTitle' | translate }}</span>
              <span>{{ 'help.contactSubTitle' | translate }}</span>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>

  <div class="menu-item">
    <button
      [ngClass]="{ 'not-hover': dropdownVisible }"
      class="un-btn btn-user hide-on-med-and-down"
      type="submit"
      (click)="toggleDropdown()"
    >
      <div class="btn-user__circle">{{ user.email | lmsInitials }}</div>
      <div class="account__tooltip">
        <span class="account__tooltip-name">{{ user.name }} {{ user.surname }}</span>
        <span>{{ user.email }}</span>
      </div>
    </button>
    <div
      class="account-submenu account-submenu__user hide-on-med-and-down"
      [ngClass]="{ visible: dropdownVisible, large: showClientDropdown }"
    >
      <ul class="account-submenu__list">
        <li *lmsProfileGuard="'accounts.access'" class="account-submenu__item account-submenu__item--padding">
          <button
            type="button"
            (click)="toggleDropdown()"
            [routerLink]="'/accounts/my-account'"
            class="un-btn btn-logout"
            title="{{ 'account.myAccount' | translate }}"
          >
            <i class="glicon-user-thin"></i>
            <span class="">{{ 'account.myAccount' | translate }}</span>
          </button>
        </li>
        <li class="account-submenu__item account-submenu__item--padding account-submenu__item--border">
          <button
            type="button"
            (click)="openCookiesConfig()"
            class="un-btn btn-logout"
            title="{{ 'account.cookies' | translate }}"
          >
            <i class="glicon-shield"></i>
            <span class="">{{ 'account.cookies' | translate }}</span>
          </button>
        </li>
        <li class="account-submenu__item account-submenu__item--padding account-submenu__item--border">
          <button type="button" (click)="logout()" class="un-btn btn-logout" title="{{ 'account.logout' | translate }}">
            <i class="glicon-logout"></i>
            <span class="">{{ 'account.logout' | translate }}</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>
